import React from 'react';
import { Typography, Box } from '@mui/material';
import ProgressModal from '../components/common/ProgressModal';
import OrganizationQuotaBanner from '../components/common/OrganizationQuotaBanner';
import FormAlert from '../components/common/FormAlert';
import ExpirationModals from '../components/common/ExpirationModals';
import CreateSimulationForm from '../components/simulations/create/CreateSimulationForm';
import useCreateSimulation from '../hooks/useCreateSimulation';

const CreateSimulation: React.FC = () => {
  const {
    // State
    formErrors,
    platforms,
    alertMessage,
    loading,
    editMode,
    
    // Handlers
    handleInputChange,
    handleSelectChange,
    handleImageChange,
    handleSubmit,
    handleCloseAlert,
    
    // Hook data
    orgInfo,
    accounts,
    user,
    state,
    dispatch,
    
    // Expiration handlers
    isTrialExpiredModalOpen,
    isTrialAdmin,
    closeTrialExpiredModal,
    isSubscriptionExpiredModalOpen,
    isSubscriptionAdmin,
    closeSubscriptionExpiredModal
  } = useCreateSimulation();
  
  return (
    <>
      <Box sx={{ mb: 4, maxWidth: 'md', mx: 'auto', px: { xs: 2, sm: 0 } }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}
        >
          New Simulation
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Enter the details of the content you want to simulate
        </Typography>
        
        <OrganizationQuotaBanner 
          orgInfo={orgInfo}
          isAdmin={user?.role === 'ADMIN'}
          resourceType="simulations"
        />
      </Box>
      
      <CreateSimulationForm
        formErrors={formErrors}
        platforms={platforms}
        accounts={accounts}
        handleInputChange={handleInputChange}
        handleSelectChange={handleSelectChange}
        handleImageChange={handleImageChange}
        handleSubmit={handleSubmit}
        state={state}
        dispatch={dispatch}
        orgInfo={orgInfo}
      />
      
      {/* Progress Modal disabled for async flow */}
      <ProgressModal
        open={false}
        title=""
        subtitle=""
        steps={[]}
        currentStep={null}
      />
      
      {/* Alert for error messages */}
      <FormAlert 
        alertMessage={alertMessage}
        onClose={handleCloseAlert}
      />
      
      {/* Expiration Modals */}
      <ExpirationModals
        isTrialExpiredModalOpen={isTrialExpiredModalOpen}
        isTrialAdmin={isTrialAdmin}
        closeTrialExpiredModal={closeTrialExpiredModal}
        isSubscriptionExpiredModalOpen={isSubscriptionExpiredModalOpen}
        isSubscriptionAdmin={isSubscriptionAdmin}
        closeSubscriptionExpiredModal={closeSubscriptionExpiredModal}
      />
    </>
  );
};

export default CreateSimulation; 
